import { Image as ImageIcon, Barcode as BarcodeIcon } from "lucide-react";

// A5 portrait — the physical dimensions used both for the on-screen
// preview aspect-ratio and the `@page size` CSS on the print sheet.
// Portrait orientation gives the card a taller canvas (148 × 210 mm)
// so long messages and stacked names don't feel cramped.
export const A5_PORTRAIT_MM = { width: 148, height: 210 };
// Legacy alias — some callers still import the landscape constant.
// Points at the same object so any old reference keeps compiling.
export const A5_LANDSCAPE_MM = A5_PORTRAIT_MM;
export const A5_ASPECT = A5_PORTRAIT_MM.width / A5_PORTRAIT_MM.height;

export const BG_POSITION_OPTIONS_LEGACY = [
  { value: "center", label: "Center" },
  { value: "top",    label: "Top" },
  { value: "bottom", label: "Bottom" },
  { value: "left",   label: "Left" },
  { value: "right",  label: "Right" },
];

// Fixed slot roster — every template exposes the same overlays so
// the POS renderer can wire them 1:1 to sale-time data.
// Slot kinds:
//   • image  — bitmap (main_image / logo)
//   • text   — single-line placeholder (to_name / from_name / value / expiry)
//   • zone   — bounding-box for wrapping text (tagline_zone / message_zone)
//   • barcode — the barcode strip
// `main_image` is always Layer 0 so it stays behind the rest.
export const OVERLAY_SLOTS = [
  { key: "main_image",   kind: "image",   label: "Main Image (background)", defaults: { x: 50, y: 50, size: 100, visible: true }, Icon: ImageIcon, noColor: true },
  { key: "logo",         kind: "image",   label: "Logo",                    defaults: { x: 8,  y: 8,  size: 18, visible: true }, Icon: ImageIcon },
  { key: "tagline_zone", kind: "zone",    label: "Tagline zone",            defaults: { x: 50, y: 22, w: 80, h: 10, size: 14, visible: true, align: "center", color: "#5b5c56" }, sourceField: "tagline" },
  { key: "message_zone", kind: "zone",    label: "Message zone",            defaults: { x: 50, y: 62, w: 80, h: 22, size: 8,  visible: true, align: "left",   color: "#2C2D28" }, sourceField: "message" },
  { key: "terms_zone",   kind: "zone",    label: "Terms & Conditions zone", defaults: { x: 50, y: 92, w: 88, h: 8,  size: 5,  visible: true, align: "center", color: "#8a8a83" }, sourceField: "terms" },
  { key: "to_name",      kind: "text",    label: "A Gift For",              defaults: { x: 8,  y: 40, size: 10, visible: true, align: "left", color: "#2C2D28" } },
  { key: "from_name",    kind: "text",    label: "From (buyer)",            defaults: { x: 8,  y: 52, size: 9,  visible: true, align: "left", color: "#2C2D28" } },
  { key: "value",        kind: "zone",    label: "Value / service",         defaults: { x: 50, y: 42, w: 60, h: 14, size: 18, visible: true, align: "center", color: "#C79A5B" }, sourceField: "__value__" },
  { key: "expiry",       kind: "text",    label: "Expiry date",             defaults: { x: 70, y: 82, size: 8,  visible: true, align: "left", color: "#5b5c56" } },
  { key: "barcode",      kind: "barcode", label: "Barcode",                 defaults: { x: 8,  y: 82, size: 22, visible: true }, Icon: BarcodeIcon },
];

export const buildDefaultOverlays = () => {
  const out = {};
  for (const s of OVERLAY_SLOTS) out[s.key] = { ...s.defaults };
  return out;
};

export const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

export const asNumber = (v, fallback) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};
